import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import { GlobalStyles } from '@experiences/theme';
import { UiText } from '@experiences/ui-common';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import { FontVariantToken } from '@uipath/apollo-core';
import React from 'react';
import { useIntl } from 'react-intl';

import { EcommerceCheckListItem } from './EcommerceCheckListItem';

const useStyles = makeStyles(theme => ({
    ...GlobalStyles(theme),
    ...createStyles({
        featuresTitle: {
            fontFamily: 'Poppins',
            fontStyle: 'normal',
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '20px',
            color: theme.palette.semantic.colorForeground,

        },
        featuresList: {
            paddingLeft: '0px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        featuresRow: {
            marginRight: '6px',
            paddingRight: '6px',
        },
    }),
}));

export const EcommerceBusinessFeaturesForCloud: React.FC = () => {
    const classes = useStyles();
    const enableEcommercePricingV2 = useFeatureFlagValue(Features.EnableEcommercePricingV2.name);
    const { formatMessage: translate } = useIntl();
    return (<div>
        <UiText
            className={classes.featuresTitle}
            data-cy="business-features-title"
            variant={FontVariantToken.fontSizeH2}>
            {translate({
                id: enableEcommercePricingV2 ?
                    'CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_TITLE' :
                    'CLIENT_ECOMMERCE_BUSINESS_FEATURES_FOR_AUTOMATION_CLOUD_PRO',
            })}
        </UiText>
        {enableEcommercePricingV2 && <ul
            className={classes.featuresList}
            data-cy="business-feature-list">
            <div className={classes.featuresRow}>
                <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_SMALL_TEAM" />
                <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_PLACEHOLDER" />
            </div>
            <div className={classes.featuresRow}>
                <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_UPTIME" />
                <EcommerceCheckListItem
                    translationId="CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_SUPPORT"
                    linkProps={{
                        href: 'https://www.uipath.com/support/packages-options',
                        translationId: 'CLIENT_ECOMMERCE_BASIC_TIER_FEATURES_SUPPORT_LINK_TEXT',
                        dataCy: 'support-packages-link',
                    }}
                />
            </div>
        </ul>}

        {!enableEcommercePricingV2 && <ul
            className={classes.featuresList}
            data-cy="business-feature-list">
            <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_TECH_SUPPORT_FROM_UI_PATH" />
            <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_ALWAYS_AVAILABLE" />
            <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_MULTI_TENANCY" />
            <EcommerceCheckListItem translationId="CLIENT_ECOMMERCE_DATA_SOVEREIGNTY" />
        </ul>}
    </div>);
};
